/**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el            = $(el);
const $celularField = $el.find('.celular-field');

const getUrlParameter = function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

let campanha = getUrlParameter('campanha');
let social = getUrlParameter('social');
let thankform = getUrlParameter('thankform');
let criativo = getUrlParameter('criativo');
let utmSource = getUrlParameter('utm_source');
let utmMedium = getUrlParameter('utm_medium');
let utmCampaign = getUrlParameter('utm_campaign');
let utmTerm = getUrlParameter('utm_term');
let utmContent = getUrlParameter('utm_content');
let gclid = getUrlParameter('gclid');

if(campanha === false) {
    campanha = "";
}

if(social === false) {
    social = "";
}

if(criativo === false) {
    criativo = "";
}

if(utmSource === false) {
    utmSource = "";
}

if(utmMedium === false) {
    utmMedium = "";
}

if(utmCampaign === false) {
    utmCampaign = "";
}

if(utmTerm === false) {
    utmTerm = "";
}

if(utmContent === false) {
    utmContent = "";
}

if(gclid === false) {
    gclid = "";
}

$el.find('form.form-simulator').validate({
    errorElement: 'span',
    errorClass: 'error',
    errorPlacement: function (error, element) {
        $el.find('form.form-simulator').removeClass('success');
    },
    rules: {
        nome: {
            required: true
        },
        email: {
            required: true,
            email: true
        },
        celular: {
            required: true
        },
        motivo: {
            required: true
        },
    },
    submitHandler: function (form) {
        const $form = $(form);
        const nome = $form.find('[name=nome]').val();
        const celular = $form.find('[name=celular]').val().replace(/([^\d])+/gim, '');
        const email = $form.find('[name=email]').val();
        const motivo = $form.find('[name=motivo]').val();

        if ($form.hasClass('sending')) {
            return false;
        }

        $form.addClass('sending');

        $.ajax({
            url: 'https://apisolar.eletrobidu.com.br/api/v1/simulacaos',
            //url: 'http://ec2-15-228-45-252.sa-east-1.compute.amazonaws.com/api/v1/simulacaos',
            type: 'POST',
            data: JSON.stringify({
                "records":[
                    {
                        "first_name": nome,
                        "email": email,
                        "phone": celular,
                        "motivo": motivo,
                        "conversao": 'form',
                        //"zip_code": '',
                        "social": social,
                        "campanha": campanha,
                        "criativo": criativo,
                        "utm_source": utmSource,
                        "utm_medium": utmMedium,
                        "utm_campaign": utmCampaign,
                        "utm_term": utmTerm,
                        "utm_content": utmContent,
                        "gclid": gclid
                    }
                ]
            }),
            dataType: 'json',
            contentType: 'application/json',
        }).done(function (data) {
            //console.log(data);
            $form[0].reset();
            $form.addClass('success');

            //window.location.href = "https://obrigado.eletrobidu.com.br/";
            window.location.href = "https://obglicenciado.eletrobidu.com.br/";

            // if(thankform == 1) {
            //     //window.location.href = "http://localhost:3000/obrigado-2?id="+data;
            //     //window.location.href = "http://johneliton.com.br/clientes/eletrobidu/lp/obrigado-2?id="+data;
            //     window.location.href = "https://thankform.eletrobidu.com.br?id="+data;
            // } else {
            //     //window.location.href = "http://localhost:3000/obrigado/";
            //     //window.location.href = "http://johneliton.com.br/clientes/eletrobidu/lp/obrigado/";
            //     window.location.href = "https://obrigado.eletrobidu.com.br/";
            // }
        }).fail(function () {
            //console.log('fail');
            $form.removeClass('success');
            $form.addClass('form-error');
        }).always(function () {
            $form.removeClass('sending');
        });

        return false;
    }
});

let sendCelular = false;

// Envio celular
$celularField.on('keyup', function(){
    let caracteres = $celularField.val().length;

    if (caracteres == 19) {
        //console.log('caracteres');

        if (!sendCelular) {
            console.log('enviar');

            const $form = $el.find('.form-simulator');
            const nome = $form.find('[name=nome]').val();
            const celular = $form.find('[name=celular]').val().replace(/([^\d])+/gim, '');
            const email = $form.find('[name=email]').val();
            let motivo = $form.find('[name=motivo]').val();

            console.log(motivo);

            if(motivo == "") {
                motivo = "não preenchido";

                console.log(motivo);
            }

            let dataForm = JSON.stringify({
                    "records":[
                        {
                            "first_name": nome,
                            "email": email,
                            "phone": celular,
                            "motivo": motivo,
                            "conversao": 'oculto',
                            //"zip_code": '',
                            "social": social,
                            "campanha": campanha,
                            "criativo": criativo,
                            "utm_source": utmSource,
                            "utm_medium": utmMedium,
                            "utm_campaign": utmCampaign,
                            "utm_term": utmTerm,
                            "utm_content": utmContent,
                            "gclid": gclid
                        }
                    ]
                });

            console.log(dataForm);

            $.ajax({
                url: 'https://apisolar.eletrobidu.com.br/api/v1/simulacaos',
                //url: 'http://ec2-15-228-45-252.sa-east-1.compute.amazonaws.com/api/v1/simulacaos',
                type: 'POST',
                data: dataForm,
                dataType: 'json',
                contentType: 'application/json',
                success: function (data) {
                    console.log('sucesso');
                }
            });

            sendCelular = true;
            console.log('envio bloqueado');

        } else {
            console.log('já foi enviado');
        }
    }

});